import  "./Service.css"
import I from "../../images/check.png"
import Navbar from "../../components/navbar/Navbar"
import Footer from "../../components/footer/Footer"
import { useParams } from "react-router-dom"
import { services } from "../../data"

const Service = () => {

  const {id} = useParams()
  const currentService = services.find((service) => service.id === Number(id))
  return (
    <>
    <Navbar/>
    <div className="service">
      <div className="serviceTop">
        <h1 className="topTitle">{currentService.title}</h1>
      </div>
      <div className="serviceCenter" key={id}>
        {currentService.images.map((image,i)=> (
          <img src={image.img} alt="" className="serviceImage" key={i} />
        ))}
      </div>
      <div className="serviceBottom">
        <h1 className="bottomTitle">What we focus more in {currentService.title}</h1>
        {currentService.points.map((point)=> (
          <div className="servicePoints">
          <img src={I} alt="" className="pointsIcon" />
          <p className="pointsPa">{point}</p>
        </div>
        ))}
      </div>
    </div>
    <Footer/>
    </>
  )
}

export default Service